










import Vue from 'vue';
import { Loader } from 'mycorems-app-shared';
import { DetailedEmailCampaign } from '@/types';
import repository from '../email-campaign-repository';
import Report from './Report.vue';

interface Data {
  task: Promise<DetailedEmailCampaign>|null,
  emailCampaign: DetailedEmailCampaign|null,
}

export default Vue.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      emailCampaign: null,
    };
  },
  watch: {
    emailCampaignId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load(): void {
      this.task = repository.find(this.emailCampaignId);
      this.task.then((emailCampaign: DetailedEmailCampaign) => {
        this.emailCampaign = emailCampaign;
      });
    },
    refresh(emailCampaign: DetailedEmailCampaign): void {
      this.emailCampaign = emailCampaign;
    },
  },
  created(): void {
    this.load();
  },
  components: {
    report: Report,
    loader: Loader,
  },
});
